export default {
  title: 'Supply Chain Management',
  supplierList: 'Supplier List',
};
